/**
 * firmApiClient
 * fetch/save/update/create/patch/delete komunikace s API
 */

import axios from 'axios'

let firmapibaseURL
firmapibaseURL = 'https://www.ceskestavby.cz/firmy/firmapi'
// firmapibaseURL = 'http://localhost:8004/firmy/firmapi'
/*
if (process.env.NODE_ENV == 'development') {
    firmapibaseURL = 'http://localhost:8004/firmy/firmapi'
} else {
    firmapibaseURL = process.env.VUE_APP_FIRMAPI_BASEURL
}
*/

console.log('firmapibaseURL', firmapibaseURL)
const axiosFirmApi = axios.create({
    baseURL: firmapibaseURL,
    headers: {
        'Content-Type': 'application/json',
    },
})

// Add a response interceptor
axiosFirmApi.interceptors.request.use(
    config => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        const accessToken = localStorage.getItem('accessToken')

        if (accessToken != null) {
            config.headers.Authorization = `Bearer ${accessToken}`
        }

        return config
    },
    error => {
        // Do something with request error
        return Promise.reject(error)
    }
)

// Add a response interceptor
axiosFirmApi.interceptors.response.use(
    response => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response
    },
    error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        // console.log(error)
        // Reject promise if usual error
        if (error.response.status == 401) {
            console.log('chyba 401')
            const refreshToken = localStorage.getItem('refreshToken')
            console.log('refreshToken', refreshToken)
            return axiosFirmApi
                .post(
                    '/auth/refresh_token/',
                    {
                        refresh_token: refreshToken,
                    },
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                    }
                )
                .then(response => {
                    console.log('reponse refresh tokenu', response)
                    // Invalid refresh token
                    if (response.status == 200) {

                        localStorage.setItem(
                            'accessToken',
                            response.data.results.access_token
                        )
                        localStorage.setItem(
                            'refreshToken',
                            response.data.results.refresh_token
                        )
                        error.response.config.headers['Authorization'] =
                            'Bearer ' + response.data.results.access_token
                    } else {
                        console.log('nepodarilo se ziskat novy token')
                    }

                    return axios(error.response.config)
                })
                .catch(error => {
                    throw new Error(
                        'chyba autentizace: nepodařilo se obnovit pristupovy token'
                    )
                })
            /*
            this.refreshToken(refreshToken)
                .then(response => {
                    console.log('reponse refresh tokenu', response)
                })
                .catch(error => {
                    console.log('nepodarilo se obnovit token')
                })
            */
            return Promise.reject(error)
        }

        if (error.response.status !== 200) {
            throw new Error(
                'chyba api: nepodařilo se získat data'
            )
        }

        return Promise.reject(error)
    }
)

const CancelToken = axios.CancelToken
let cancelIco

export default {
    /**
     * vrací údaje přihlášeného uživatele
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchUser() {
        return axiosFirmApi.get('/user/')
    },
    /**
     * vrací firmy nalezené podle IČO
     * @param {string} searchText
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchIco(searchText) {
        if (cancelIco !== undefined) {
            cancelIco()
        }
        return axiosFirmApi.get('/ico/?searchText=' + searchText, {
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelIco = c
            }),
        })
    },
    /**
     * vrací firmy nalezené podle názvu nebo IČO
     * @param {string} searchText
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchAres(searchText) {
        return axiosFirmApi.get('/ares/?searchIco=' + searchText)
    },
    /**
     * vrací registrované firmy s IČO
     * @param {string} searchText
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchRegisteredFirms(searchText) {
        return axiosFirmApi.get('/check/?ico=' + searchText)
    },
    /**
     * vrací seznam možných prezentací firmy pro výběr
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchPresentations(id_crm) {
        return axiosFirmApi.get('/presentations/?id_crm=' + id_crm)
    },
    /**
     * vrací detail registrované firmy
     * @param  {number} id_firmy
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetchDetail(id_firmy) {
        return axiosFirmApi.get('/detail/?id_firmy=' + id_firmy)
    },
    fetchMajitelFirmy(id_firmy) {
        return axiosFirmApi.get('/majitel_firmy/?id_firmy=' + id_firmy)
    },
    /**
     * zaregistruje firmu do databáze a vrací její id_firmy, opravny_kod...
     * @param {Object} ares_data
     * @param {Object} form_data
     * @param {Object} presentation
     * @param {number} user_id
     * @param {string} user_token
     * @returns {Promise<AxiosResponse<T>>}
     */
    createFirm(ares_data, form_data, presentation, id_crm, sandbox) {
        return axiosFirmApi.post(
            '/firm/',
            {
                ico: ares_data.ico,
                dic: ares_data.dic,
                firma: ares_data.firma,
                ulice: ares_data.ulice,
                cislo: ares_data.cislo,
                mesto: ares_data.mesto,
                psc: ares_data.psc,
                kod_okresu: ares_data.kod_okresu,
                kod_obce: ares_data.kod_obce,
                kod_casti_obce: ares_data.kod_casti_obce,
                kod_ulice: ares_data.kod_ulice,
                lat: ares_data.lat,
                lon: ares_data.lon,
                id_adresy: ares_data.id_adresy,
                adrupresneni: ares_data.adrupresneni,
                kf_kategorie: '',
                mobil: '',
                telefon: form_data.telefon,
                email: form_data.email,
                www: form_data.www,
                login: form_data.email,
                password: '',
                poznamka: form_data.popis,
                infomail: 0,
                ip: '',
                souhlas_gdpr: 1,
                presentation: presentation.id,
                id_crm: id_crm,
                sandbox: sandbox,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    /**
     * spustí skript zapisující firmu z DB do CRM
     * @param {number} id_firmy
     * @param {string} hash
     * @returns {Promise<AxiosResponse<T>>}
     */
    executeScriptCeskyseznam2CRM(id_firmy, hash, sandbox) {
        return axiosFirmApi.get(
            '/execute_script_ceskyseznam2crm/?id_firmy=' +
                id_firmy +
                '&opravny_kod=' +
                hash +
                '&sandbox=' +
                sandbox
        )
    },
    /**
     * spustí skript na přepočítání kategorií
     * @param {number} id_firmy
     * @returns {Promise<AxiosResponse<T>>}
     */
    executeScriptAdresare(id_firmy) {
        return axiosFirmApi.get(
            '/execute_script_adresare/?id_firmy=' + id_firmy
        )
    },
    /**
     * spustí skript na zápis firmy do firmy_neblokovane, pracuje s ní katalog firem
     * @param {number} id_firmy
     * @returns {Promise<AxiosResponse<T>>}
     */
    executeScriptFirmyNeblokovaneTabulky(id_firmy) {
        return axiosFirmApi.get(
            '/execute_script_firmy_neblokovane_tabulky/?id_firmy=' + id_firmy
        )
    },
    /**
     * vytvoří objednávku služeb v CRM
     * @param {number} id_firmy
     * @param {string} opravny_kod
     * @param {number}  presentation_id
     * @param {number} user_id
     * @param {string} user_token
     * @returns {Promise<AxiosResponse<T>>}
     */
    createOrder(
        crm,
        id_firmy,
        opravny_kod,
        cena,
        sandbox,
        presentation_id,
        user_id,
        user_token,
        platba
    ) {
        return axiosFirmApi.post(
            '/order/create/',
            {
                crm,
                id_firmy,
                opravny_kod,
                cena,
                sandbox,
                presentation_id,
                platba,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    changeOrderPaymentMethod(
        crm,
        id_firmy,
        opravny_kod,
        hash_objednavky,
        id_historie,
        sandbox,
        platba
    ) {
        return axiosFirmApi.post(
            '/order/change_payment_method/',
            {
                crm,
                id_firmy,
                opravny_kod,
                hash_objednavky,
                id_historie,
                sandbox,
                platba,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    changeOrderPaymentStatus(
        crm,
        id_firmy,
        opravny_kod,
        hash_objednavky,
        id_historie,
        sandbox,
        status
    ) {
        return axiosFirmApi.post(
            '/order/change_payment_status/',
            {
                crm,
                id_firmy,
                opravny_kod,
                hash_objednavky,
                id_historie,
                sandbox,
                status,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    fetchGopayToken(sandbox) {
        return axiosFirmApi.get('/gopay/token/' + '?sandbox=' + sandbox)
    },
    createGopayPayment(
        crm,
        id_firmy,
        gopay_access_token,
        amount,
        order_number,
        invoicenumber,
        return_url,
        notification_url,
        sandbox
    ) {
        console.log('gopay_access_token', gopay_access_token)
        return axiosFirmApi.post(
            '/gopay/payment/?sandbox=' + sandbox,
            {
                crm,
                id_firmy,
                access_token: gopay_access_token,
                amount,
                order_number,
                invoicenumber,
                return_url,
                notification_url,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    fetchGopayState(id, gopay_access_token, sandbox) {
        return axiosFirmApi.post(
            '/gopay/state/?sandbox=' + sandbox,
            {
                id,
                access_token: gopay_access_token,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    createLoggerMessage(message) {
        return axiosFirmApi.post(
            '/logger/create/',
            {
                message,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    refreshToken(refreshToken) {
        return axiosFirmApi.post(
            '/auth/refresh_token/',
            {
                refresh_token: refreshToken,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    fetchForgottenPassword(email) {
        return axiosFirmApi.post(
            '/auth/forgotten_password/',
            {
                email,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
    setOfferRequest(crm, id_firmy, opravny_kod) {
        return axiosFirmApi.post(
            '/offer_request/',
            {
                crm,
                id_firmy,
                opravny_kod,
            },
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }
        )
    },
}
